import { css } from 'linaria';

export const hidden = css`
  display: none;
`;
